// *********************************************************************************************
//   Implementation of the VC services which are services that are accessible
//   from extensions.
// *********************************************************************************************
/// <amd-module name="VC/RemoteServices/VersionControlRepositoryService" />
import { ServiceOptions, Services, VssService } from "VSS/Platform/Context";

import { GitRepository } from "VC/Common/Contracts/Git";
import { IVCNavigationService } from "VC/Common/Navigation";

export class VersionControlRepositoryService extends VssService {
    /**
     * Gets the currently selected Git repository. Returns null if a Git repository is not currently selected.
     */
    // Note: Returns a promsie because the extension SDK will end up handing back a promise even if we return the object
    // directly. This way the method signature matches the behavior the user will get (avoiding possible confusion).
    public getCurrentGitRepository(): Promise<GitRepository | null> {
        const navService = this.pageContext.getService<IVCNavigationService>("IVCNavigationService");
        const providerData = navService.getData();

        if (providerData && providerData.defaultRepoIsGit) {
            return Promise.resolve(<GitRepository>{
                name: providerData.defaultGitRepoName,
                id: providerData.defaultRepoId,
                url: providerData.defaultGitRepoUrl,
                isFork: providerData.defaultRepoIsFork
            });
        }

        return Promise.resolve(null);
    }
}

Services.add("ms.vss-code-web.vc-repository-service", { serviceFactory: VersionControlRepositoryService, options: ServiceOptions.Remotable });
